module.exports = __webpack_public_path__ + "img/eshoy_gold_more.22f586b1.png";